import { createActions } from 'redux-actions';

const SET_HEADER = 'SET_HEADER';
const RERENDER_APPLICATION = 'RERENDER_APPLICATION';

const actionOptions = {
  prefix: 'app/menu',
};

const actions = createActions(
  {},
  SET_HEADER,
  RERENDER_APPLICATION,
  actionOptions,
);

export const { setHeader, rerenderApplication } = actions;
